import {router} from "@inertiajs/vue3";
import FormButtons from "@/pages/components/form-buttons.vue";

export default {
	components: {FormButtons},

	data() {
		return {
			formRoute: '',
			redirectRoute: '',
			stayOnPageRedirect: undefined,
			loading: false,
			stayOnPage: 1
		}
	},

	methods: {
		submit() {
			this.loading = true;
			let form = {};
			if(this.form) {
				form = this.form;
			} else {
				form = this.$refs.form.form;
			}

			$.ajax({
				url: this.formRoute,
				method: this.getFormMethod(),
				contentType: "application/json",
				processData: false,
				data: JSON.stringify(form.data()),
				success: this.onSuccess.bind(this, form),
				error: this.onError.bind(this, form),
			}).always(() => {
				this.loading = false;
				this.afterSubmit(form);
			})
		},

		onSuccess(form, response) {
			form.reset('password', 'password_confirmation');
			form.isDirty = false;

			if (this.stayOnPageRedirect) {
				let stayOnPageRedirect = this.stayOnPageRedirect;

				if (response.data) {
					for (let key in response.data) {
						stayOnPageRedirect = stayOnPageRedirect.replace(`_${key}_`, response.data[key]);
					}
				}

				let target = this.stayOnPage ? stayOnPageRedirect : this.redirectRoute

				router.get(target, {
					'success': this.getSuccessMessage()
				});

				return;
			}

			Helpers.Message.success(this.getSuccessMessage());

			this.afterSuccess(form, response)
		},

		afterSuccess(form, response) {

		},

		afterSubmit(form) {

		},

		onError(form, response) {
			Helpers.Form.handleErrors(form, response);
		},

		getSuccessMessage() {
			return 'De wijzigingen zijn opgeslagen';
		},

		getFormMethod() {
			return 'POST'
		}
	}
}